module.exports = __webpack_public_path__ + "static/media/HoverIcon.bd2d3691.svg";